export default __webpack_public_path__ + "static/media/lauren_brown.d61fdf99.jpeg";